import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';

import { FechasService } from 'src/app/services/fechas/fechas';
import { ControlService } from 'src/app/services/control/control.service';
import { ImprimiService } from 'src/app/services/imprimir/imprimirService';
import { FirmaService } from 'src/app/services/firma/firmaService';
import { estilos_informes } from 'src/app/config/estilos-informes';
import { logo } from 'src/app/config/imagenes';
import { ImageBaseService } from 'src/app/services/imagenes/imagenes.service';
import { url } from 'src/app/config/config';
import { VariedadesService } from 'src/app/services/variedades/variedades';
import { environment } from 'src/environments/environment';


declare var $: any;



@Component({
    selector: 'app-imprimir-pesos',
    templateUrl: './imprimir-pesos.component.html',
    styleUrls: ['./imprimir-pesos.component.css'],
    providers: [ImprimiService, FirmaService]

})
export class ImprimirPesosComponent implements OnInit, OnDestroy, OnChanges {



    @Input() title: string;
    @Input() id: string;
    @Input() database: string;
    @Output() cerrarVentana = new EventEmitter();
    @Input() hiddenButtons: string ='false';
    @Input() folderName: string;

    public firma = '';
    public firma_revision = '';
    public revision = '';
    public baseUrl = url + "upload/firmas/";

    public anexo = new Date();
    public productos: any = [];
    public oldId = "";
    public oldDatabase = "";
    public productosKey: any[] = [];
    public estructurado: any[] = [];
    public fechaActual = this.fechaService.mostrarFechaActual();
    public closeWindow = true;
    public pesos: any[] = [];
    public pesos_horas: any[] = [];

    public arrayPesos: any[] = [];
    public url: string= url +"upload/pesos/pitufo/";
    public imgURL: any="https://via.placeholder.com/150/808080/FFFFFF?Text=Digital.com";

    public etiqueta: any = []; 
    public etiquetaFile: File ; 


    public responsable: string = '';
    public observaciones = '';
    public logo: string = "";
    public procedimiento: string = '4';
    public numero_anexo: string = 'VII';
    public fecha: any = []; 
    public field: string = '';
    public loading = true;

    public variedadesList: any[] = []
    private variedadesMap: { [id: string]: string } = {};

    // public urlEtiqueta: string = url + 'upload/PesoPitufo/'
    public urlEtiqueta: string = url + 'upload/'
   

    constructor(
        private fechaService: FechasService,
        private firmaService: FirmaService,
        private imprimirService: ImprimiService,
        private ImageBaseService: ImageBaseService,
        private variedadesService: VariedadesService
        ) {
        this.oldId = this.id;
    }
    public myMap = new Map([]);
    ngOnInit(): void {

       /*  this.ImageBaseService.image64(logo).toPromise()
        .then( (resp: string) => {
           
            this.logo = resp;
        }).catch( error => {
            this.logo = logo;
        }); */
        // this.mostrarContenido();
        this.getLists()

    }
    ngOnDestroy(): void {

    }
    ngOnChanges(changes: SimpleChanges) {
        if (this.id) {
            if (this.oldId != this.id) {
                this.pesos = [];
                this.mostrarContenido();
            }

        } else {

        }

    }
   
    mostrarContenido() {

        this.firma_revision = '';
        this.revision = '';
        
        this.imprimirService.getId(this.id, this.database).subscribe((resp: any) => {

            

            // if (environment.appName === 'tresfrut'){
                resp.forEach(item => {
                    item.Variedad = this.variedadesMap[item.Variedad] || item.Variedad
                })    
            // }
            
            this.productos = resp.map(item => this.normalizeKeys(item));
            this.fecha = this.productos[0]['fecha'];
            
            try {
                this.ImageBaseService.image64(this.urlEtiqueta + this.folderName + '/' + resp[0].etiqueta_archivo).toPromise().
                then(  (imagen64) => {
                   
                    this.etiqueta = imagen64;       
                     this.etiquetaFile = this.dataURLtoFile( imagen64, 'imagen.jpeg');
                     
                     this.handleFiles(this.etiquetaFile);
                     this.resizedataURL(this.urlEtiqueta + this.folderName + '/' +  resp[0].etiqueta_archivo,200,200);
                      
                })
               
               
                resp[0].etiqueta_archivo
            } catch (error) {
                
            } 
            try {
                this.responsable = resp[0].Responsable;
                this.firmaService.getFirma(resp[0].Responsable).toPromise().then((data: any) => {
                    // console.log("data",data);
                    if (data.productos[0].firma) {
                        this.firma = this.baseUrl + data.productos[0].firma;
                        //console.log("firma "+this.firma);

                    } else {
                        //console.log("no hay firma");

                        this.firma = null;
                    }

                }).catch(error => {
                    //console.log("error ",error);
                    this.firma = null;
                });
                this.revision = resp[0].revision;
                this.firmaService.getFirma(resp[0].revision).toPromise().then((data: any) => {
                    // console.log("data",data);
                    if (data.productos[0].firma) {
                        this.firma_revision = this.baseUrl + data.productos[0].firma;
                        //console.log("firma "+this.firma);

                    } else {
                        //console.log("no hay firma");

                        this.firma_revision = null;
                    }

                }).catch(error => {
                    //console.log("error ",error);
                    this.firma_revision = null;
                });
            } catch (error) {
                this.firma = null;
            }
            this.productos = resp.map(item => this.normalizeKeys(item));
            this.productos[0]['maquina'] = this.productos[0]['Máquina'];
            this.productos[0]['confeccion'] = this.productos[0]['Confección'];
            this.productos[0]['diferencia'] = this.comprobarCalidad(this.productos[0] );
            this.observaciones = this.productos[0]['observaciones'];
            let recogerPalabra = "";
            let recogercadenas = [];

            let separarFEcha = "";

            //console.log('productos[0]',this.productos[0]);
            

            let number = 0;
            for (const key in this.productos[0]) {


                if (recogerPalabra == "Pesos") {
                    this.pesos = [];
                    this.pesos_horas = []; 
                    let myPeso = [];
                    let arreglarPesos = this.productos[0]['Pesos'].split(";");
                    let arreglarPesosHoras = this.productos[0]['Pesos_horas'].split(";");
                    for (let index = 0; index < arreglarPesosHoras.length; index++) {
                        arreglarPesosHoras[index] = arreglarPesosHoras[index] == 'UNDEFINED' ? '' : arreglarPesosHoras[index] ;
                    }
                    //console.log("arreglarpesos",arreglarPesos);
                    let contadorPesos = 0;
                    for (let index = 0; index < arreglarPesos.length; index++) {
                        if (arreglarPesos[index] == "") {

                        } else {
                            myPeso.push(arreglarPesos[index]+'/'+ arreglarPesosHoras[index]  );

                        }

                        if (((index + 1) % 4) == 0 && index > 0) {

                            let arreglopesos = new Array();
                            arreglarPesos.push();
                            this.pesos.push(myPeso);

                            myPeso = [];



                        }
                        if (index == arreglarPesos.length - 2) {
                            this.pesos.push(myPeso);

                            // console.log("myPeso",myPeso);
                            //myPeso=[];

                        }

                    }

                    //console.log("Pesos",this.pesos);
                } else {



                    this.productosKey.push([key]);
                    recogerPalabra = key;
                    recogercadenas = [];


                }


                separarFEcha = this.productos[0]['Fecha'].split("/");

                let estructurarFEcha = separarFEcha[2] + "-" + separarFEcha[1] + "-" + separarFEcha[0];
                this.fecha = estructurarFEcha;
                if (number == 0) {

                  /*   this.imprimirService.getAnexo(estructurarFEcha, this.database).subscribe(resp => {

                        try {
                            if (resp[0]['fecha_anexo'] === undefined) {
                                this.anexo = new Date();
                            } else {
                                this.anexo = resp[0]['fecha_anexo'];
                            }
                        } catch (error) {
                            this.anexo = new Date();
                        }


                    }); */
                    number++;
                } else {

                }


               

            }
            this.loading = false;
            //console.log("estructurado", this.estructurado);

        });

    }
    comprobarCalidad( data: any) {
       // console.log("comprobar calidad",data);
        
          let result = new Array();
          let myRespuesta = '';
      
          
          if (data.global_gap !== null && data.global_gap !== undefined && data.global_gap.localeCompare('1') == 0 ) {
              result.push('Global gap')
          }
          if (data.IGP !== null && data.IGP !== undefined && data.IGP.localeCompare('1') == 0 ) {
              result.push('IGP')
          }
          if (data.prod_integrado !== null && data.prod_integrado !== undefined && data.prod_integrado.localeCompare('1') == 0 ) {
              result.push('Producción integrada')
          }
          if (data.residuo !== null && data.residuo !== undefined && data.residuo.localeCompare('1') == 0 ) {
              result.push('Residuo 0')
          }
        
          if (result.length == 0 ) {
            return myRespuesta;
          } else {
            return myRespuesta = result.toString();
          }
        }


    jsUcfirst(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    imprimir() {
        let o = {
            filename: 'documento.doc',
            area: 'div.googoose',
            margins: '1in',
            headermargin: '0.5in',
            display: 'Print',
            /*    lang: 'es-ES', */
            lang: 'es-ES',
            download: true
        };
        //debugger;


        let res = $(document).googoose(o);
    }
    exportHTML() {
        var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
            "xmlns:w='urn:schemas-microsoft-com:office:word' " +
            "xmlns='http://www.w3.org/TR/REC-html40'>" +
            "<head><meta charset='utf-8'>" +
            "<style>" +
            "table{" +
            "  border: 1px solid black !important;" +
            "min-width:90% !important" +
            "}" +
            "td,th{" +
            " font-weight: bold;" +
            "padding: 4px;" +
            "text-align: center;" +
            "background-color: white;" +
            "} table-pesos { width: 600px !important }" +
            "</style>" +
            "<title>Export HTML to Word Document with JavaScript</title></head><body>";
        var footer = "</body></html>";
        var sourceHTML = header + document.getElementById("source-html").innerHTML + footer;

        var source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
        var fileDownload = document.createElement("a");
        document.body.appendChild(fileDownload);
        fileDownload.href = source;
        fileDownload.download = 'document.doc';
        fileDownload.click();
        document.body.removeChild(fileDownload);
    }

    Export2Doc() {
        //this.convertImagesToBase64();

        var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title>"
        + "<style>" + estilos_informes + "<div style=' font-family: Arial; font-size: 12px;'>";
        var postHtml = "</div></body></html>";
        var html = preHtml + document.getElementById('source-html').innerHTML + postHtml;

        var blob = new Blob(['\ufeff', html], {
            type: 'application/msword'
        });

        // Specify link url
        var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
        let filename = "";
        // Specify file name
        filename = filename ? filename + '.doc' : 'pesos malla girsac.doc';

        // Create download link element
        var downloadLink = document.createElement("a");

        document.body.appendChild(downloadLink);

        if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            // Create a link to the file
            downloadLink.href = url;

            // Setting the file name
            downloadLink.download = filename;

            //triggering the function
            downloadLink.click();
        }

        document.body.removeChild(downloadLink);
    }

    sustituirAcentos(cadena: String) {
        //console.log("cadena",cadena.length);
        var especiales = ["Á", "É", "Í", "Ó", "Ú", "ñ", "á", "é", "í", "ó", "ú"];
        let sustitutos = ["&Aacute", "&Eacute", "IAacute", "&Oacute", "&Uacute", "&ntilde", "&aacute", "&eacute", "&iacute", "&oacute", "&uacute"];
        let nuevaCadena = "";
        let discriminador = false;
        let numero = cadena.length;

        for (let index = 0; index < numero; index++) {
            discriminador = false;
            for (let j = 0; j < especiales.length; j++) {

                if ((cadena.charAt(index)) == especiales[j]) {
                    nuevaCadena += sustitutos[j];
                    discriminador = true;

                }
            }
            //console.log("charAt"+cadena.charAt(index));
            if (discriminador) {

            } else {
                nuevaCadena += cadena.charAt(index);
            }

        }
        return nuevaCadena;

    }

    convertImagesToBase64() {

        let regularImages = document.getElementById("source-html").querySelectorAll("img");

        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        [].forEach.call(regularImages, function (imgElement) {
            // preparing canvas for drawing
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            canvas.width = imgElement.width;
            canvas.height = imgElement.height;
            ctx.drawImage(imgElement, 0, 0);
            // by default toDataURL() produces png image, but you can also export to jpeg
            // checkout function's documentation for more details
            var dataURL = canvas.toDataURL();

            debugger;
            imgElement.setAttribute('src', dataURL);
        })
        canvas.remove();
    }

    cerrar() {
        this.cerrarVentana.emit({ closeWindow: false });
    }


    checkObservaciones(campo: string, value:string ) {
        if( campo.localeCompare('Observaciones') == 0 ) {
            if( value == null || value == undefined ) {
                return false;
            }
            if( value.length <= 0 ) {
                return false;
            }
            return true;
        }
        return true;
    }

    resizeImage(resp, maxWidth = 400, maxHeight = 350)  {
        return new Promise((resolve) => {
          let img = new Image()
          img.src = resp
          img.onload = () => {
            let canvas = document.createElement('canvas')
            const MAX_WIDTH = maxWidth
            const MAX_HEIGHT = maxHeight
            let width = img.width
            let height = img.height
      
            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width
                width = MAX_WIDTH
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height
                height = MAX_HEIGHT
              }
            }
            canvas.width = width
            canvas.height = height
            let ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0, width, height)
            
            
            resolve(canvas.toDataURL())
          }
        })
      }
    
      dataURLtoFile(dataurl, filename) {
     
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), 
            n = bstr.length, 
            u8arr = new Uint8Array(n);
            
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        
        return new File([u8arr], filename, {type:mime});
    }
    
    handleFiles(e) {
        var canvas:any =document.getElementById("canvas");
        if (canvas) {
            
            var ctx=canvas.getContext("2d");
        }else{
            console.error("No se encontró el elemento canvas con id 'canvas'");
        }
    var cw=canvas.width;
    var ch=canvas.height;
    var maxW = 350;
    var maxH = 350;
    
    
    
        var img = new Image;
        img.onload = () => {
          var iw=img.width;
          var ih=img.height;
          var scale = Math.min((maxW/iw),(maxH/ih));
          var iwScaled=iw*scale;
          var ihScaled=ih*scale;
          canvas.width=iwScaled;
          canvas.height=ihScaled;
          ctx.drawImage(img,0,0,iwScaled,ihScaled);
          this.etiqueta  = canvas.toDataURL("image/jpeg",1);
          canvas.remove();
        
          
        }
        img.src = URL.createObjectURL(e);
        
        
      }
      resizedataURL(datas, wantedWidth, wantedHeight){
        return new Promise(async function(resolve,reject){
            
            // We create an image to receive the Data URI
            var img = document.createElement('img');
    
            // When the event "onload" is triggered we can resize the image.
            img.onload = function()
            {        
                // We create a canvas and get its context.
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');
    
                // We set the dimensions at the wanted size.
                canvas.width = wantedWidth;
                canvas.height = wantedHeight;
    
                // We resize the image with the canvas method drawImage();
                ctx.drawImage(img, 0, 0, wantedWidth, wantedHeight);
    
                var dataURI = canvas.toDataURL();
                
                
                // This is the return of the Promise
                resolve(dataURI);
            };
    
            // We put the Data URI in the image's src attribute
            img.src = datas;
            
            
        });
    }

    buildMaps(){
        this.variedadesList.forEach(variedad => {
            this.variedadesMap[variedad.id] = variedad.nombre
        })
    }

    getLists(){
        this.variedadesService.listVariedad().subscribe((variedad:any) => {
            this.variedadesList = variedad

            this.buildMaps()
            this.mostrarContenido()
        })
    }

    normalizeKeys(obj) {
        const newObj = {};
        Object.keys(obj).forEach(key => {
          // Remove quotes and any trailing spaces from the key
          const newKey = key.replace(/^"|"$/g, '').trim();
          newObj[newKey] = obj[key];
        });
        return newObj;
      }

}